import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import ALoader from 'views/pages/manage/common/a-loader';
import { columns, newRow } from './constant';
import { Card, CardBody } from 'reactstrap';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { GridRowModes } from '@mui/x-data-grid';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { isObjEmpty } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { generateRandomId } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { ActionsCellComponent } from 'views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common';
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import { ReactComponent as CancelIcon } from 'assets/img/svg/RedCancel.svg';

const ListComponent = forwardRef(({
    rows,
    selectedTab,
    loader,
    dropdowns,
    createUpdateHandler,
    deleteHandler,
    currentPage,
    getMappingList,
    rowCount,
    currPageSize,
    setRowForm,
    rowForm,
    userPermissions
}, ref) => {

    const [rowModesModel, setRowModesModel] = useState({});
    const [rowData, setRowData] = useState(rows);

    const rowFormHandler = (value, key) =>
        setRowForm((prev) => ({ ...prev, [key]: value }));

    useEffect(() => {
        setRowData(rows);
    }, [rows]);

    const startEditing = (id, form) => {
        setRowModesModel((oldModel) => ({
            [id]: { mode: GridRowModes.Edit },
        }));
        setRowForm(form);
    };

    const stopEditing = () => {
        const currForm = { ...rowForm };
        setRowModesModel((oldModel) => ({
            [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRowForm({});
    };

    const handleEditClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            startEditing(params?.id, params?.row);
        }
    };
    const handleDeleteClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            deleteHandler(params?.row)
        }
    }

    const handleCancelClick = async (params) => {
        if (params?.row?.isNew) {
            setRowData(rows);
            setRowForm({});
        } else {
            stopEditing(params?.id);
        }
    };

    const handleSaveClick = async (params) => {
        createUpdateHandler(rowForm);
    };

    const addNewRow = async () => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            let emptyRow = {
                ...newRow,
                isNew: true,
                id: generateRandomId(),
            };
            // let randomId = JSON.stringify(emptyRow);
            startEditing(emptyRow?.id, emptyRow);
            setRowData((prev) => [emptyRow, ...prev]);
        }
    };

    useImperativeHandle(ref, () => ({
        addNewRow: addNewRow,
        startEditing: startEditing,
        stopEditing: stopEditing,
    }));

    const actionColumn = selectedTab?.key!='logs'&&(userPermissions?.includes("C") ||userPermissions?.includes("U"))?[
        new AGridColDef('actions', 'Action', false)
            .setMinWidth(100)
            .setFlex(1)
            .editable(true)
            // .pinColumnLast(true)
            .columnAlign('right')
            .renderCellComponent(params =>
                <ActionsCellComponent
                    mode={'view'}
                    handleEditClick={handleEditClick}
                    handleSaveClick={handleSaveClick}
                    handleCancelClick={handleCancelClick}
                    handleDeleteClick={handleDeleteClick}
                    icon={true}
                    cancelIcon={true}
                    deleteIcon={true}
                    params={params}
                    editPermission={userPermissions?.includes("U")}
                    deletePermission={userPermissions?.includes("D")}
                    customEditIcon
                />
            )
            .renderEditCellComponent(params => (
                <ActionsCellComponent
                    mode={'edit'}
                    handleSaveClick={handleSaveClick}
                    handleCancelClick={handleCancelClick}
                    handleDeleteClick={handleDeleteClick}
                    icon={true}
                    cancelIcon={<CancelIcon
                        className="mx-2 cursor"
                        onClick={() => handleCancelClick(params)}
                    />}
                    deleteIcon={true}
                    params={params}
                isSaveDisabled={!(rowForm?.phoenixValueId && rowForm?.honoValue )}
                />))]:[]

    const columnDefs = useMemo(() => {
        const colFn = columns?.[selectedTab?.key];
        return typeof colFn === 'function' ? colFn(dropdowns?.[selectedTab?.key], rowFormHandler, rowForm) : colFn;
    }, [selectedTab, dropdowns, rowForm]);

    const onChangeHandler = (page, pageSize) => {
        getMappingList(page, pageSize)
    }


    return (<>
        {loader && <ALoader position="fixed" />}
        <ADataGrid
            removeWrapperContainer
            rowModesModel={rowModesModel}
            rows={rowData || []}
            columns={[...columnDefs, ...actionColumn]}
            rowId={(row) => row?.id}
            rowHeight={50}
            loading={false}
            rowCount={rowCount}
            currentPage={currentPage}
            nextButtonHandler={onChangeHandler}
            sx={{
                ...gridStyles,
            }}
            autoHeight
            pinLastColumn={selectedTab?.key!='logs'&&(userPermissions?.includes("C") ||userPermissions?.includes("U"))?true:false}
            paginationModel={{ page: currentPage, pageSize: currPageSize }}
        />

    </>
    );
})

export default ListComponent;